import api from './client';

/** Returns { thumbnails } — the full list of carousel items from the database. */
export const fetchSections = () => api.get('/api/sections');


/** Returns { thumbnails } — the full list of carousel items from the database. */
export const fetchSection = (sectionName) => api.get(`/api/sections/${sectionName}`);